import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "error-trigger",
  "name": "Error Trigger",
  "category": "triggers",
  "description": "Trigger workflow when another workflow fails",
  "icon": "AlertTriangle",
  "color": "red",
  "version": "1.0.0",
  "group": [
    "trigger"
  ],
  "defaults": {
    "name": "Error Trigger",
    "color": "#ef4444"
  },
  "inputs": [],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Main"
    }
  ],
  "tags": [
    "error",
    "trigger",
    "fail",
    "exception",
    "catch"
  ],
  "comingSoon": false
};

export default definition;
